import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getInvoicesListDownload =
  (start, end, {dealer, searchScope, dealerAgency}) => (dispatch) => {
    return dispatch(
      apiActionCreator({
        // eslint-disable-next-line max-len
        'endpoint': `/invoices/download-list?start=${start}&end=${end}&dealer=${dealer}&scope=${searchScope}&agency=${dealerAgency}`,
        'authenticated': true,
        'types': [
          ActionTypes.FETCHING_INVOICES_DOWNLOAD_LIST,
          ActionTypes.FETCHED_INVOICES_DOWNLOAD_LIST,
          [
            ActionTypes.FETCHED_INVOICES_DOWNLOAD_LIST_FAILED,
            (error) => buildErrorMessage(error),
          ],
        ],
        'microservice': 'part',
        'method': 'GET',
      })
    );
  };

export const clearInvoicesListDownload = () => ({
  'type': ActionTypes.CLEAR_INVOICES_DOWNLOAD_LIST,
});
